var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticStyle:{"min-height":"0px"}},[_c('p',{staticClass:"text-justify text-xs"},[_vm._v(" "+_vm._s(_vm.indicatorDisclaimerText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }